<template>
    <div v-if="showFilters" class="border bg-white rounded-lg shadow p-4">
        <h2 class="mb-4">Filters</h2>
        <div class="grid grid-cols-3 gap-4">
            <div
                class="w-full"
            >
                <p class="text-gray-700 mb-2 text-sm">Bonus Types</p>

                <select2
                    :options="filterOptions.bonusTypes"
                    key="bonus_types"
                    :multiple="true"
                    id="bonus_types"
                    select-label="name"
                    track-by-option="id"
                    name="bonus_types"
                    class="mt-1"
                    @sync="(value) => filterChanged('bonusTypes', value)"
                    :value="value.bonusTypes"
                />
            </div>

            <div
                class="w-full"
            >
                <p class="text-gray-700 mb-2 text-sm">Game Types</p>
                <select2
                    :options="filterOptions.gameTypes"
                    key="game_types"
                    :multiple="true"
                    id="game_types"
                    select-label="name"
                    track-by-option="id"
                    name="game_types"
                    class="mt-1"
                    @sync="(value) => filterChanged('gameTypes', value)"
                    :value="value.gameTypes"
                />
            </div>

            <div
                class="w-full"
            >
                <p class="text-gray-700 mb-2 text-sm">Payment Methods</p>
                <select2
                    :options="filterOptions.paymentMethods"
                    key="payment_methods"
                    :multiple="true"
                    id="payment_methods"
                    select-label="name"
                    track-by-option="id"
                    name="payment_methods"
                    class="mt-1"
                    @sync="(value) => filterChanged('paymentMethods', value)"
                    :value="value.paymentMethods"
                />
            </div>

            <div
                class="w-full"
            >
                <p class="text-gray-700 mb-2 text-sm">Software</p>
                <select2
                    :options="filterOptions.software"
                    key="software"
                    :multiple="true"
                    id="software"
                    select-label="name"
                    track-by-option="id"
                    name="software"
                    class="mt-1"
                    @sync="(value) => filterChanged('software', value)"
                    :value="value.software"
                />
            </div>

            <div
                class="w-full"
            >
                <p class="text-gray-700 mb-2 text-sm">Countries</p>
                <select2
                    :options="filterOptions.countries"
                    key="countries"
                    :multiple="true"
                    id="countries"
                    select-label="name"
                    track-by-option="id"
                    name="countries"
                    class="mt-1"
                    @sync="(value) => filterChanged('countries', value)"
                    :value="value.countries"
                />
            </div>

            <div
                class="w-full"
            >
                <p class="text-gray-700 mb-2 text-sm">Licenses</p>
                <select2
                    :options="filterOptions.licenses"
                    key="licenses"
                    :multiple="true"
                    id="licenses"
                    select-label="name"
                    track-by-option="id"
                    name="licenses"
                    class="mt-1"
                    @sync="(value) => filterChanged('licenses', value)"
                    :value="value.licenses"
                />
            </div>

            <div
                class="w-full"
            >
                <p class="text-gray-700 mb-2 text-sm">Currencies</p>
                <select2
                    :options="filterOptions.currencies"
                    key="currencies"
                    :multiple="true"
                    id="currencies"
                    select-label="name"
                    track-by-option="id"
                    name="currencies"
                    class="mt-1"
                    @sync="(value) => filterChanged('currencies', value)"
                    :value="value.currencies"
                />
            </div>

            <div
                class="w-full"
            >
                <p class="text-gray-700 mb-2 text-sm">Launch Date</p>
                <Select
                    name="launch_date"
                    v-model="value.launchDate"
                    no-padding
                    placeholder="Select a launch date"
                    :options="[
                        {value: null, name: 'Select a launch date'},
                        {value: 6, name: 'last 6 months'},
                        {value: 12, name: 'last 12 months'},
                        {value: 18, name: 'last 1.5 years'},
                        {value: 24, name: 'last 2 years'},
                        {value: 30, name: 'last 2.5 years'},
                        {value: 36, name: 'last 3 years'},
                        {value: 42, name: 'last 3.5 years'},
                        {value: 48, name: 'last 4 years'},
                        {value: 54, name: 'last 4.5 years'},
                        {value: 60, name: 'last 5 years'},
                    ]"
                />
            </div>
            <div
                class="w-full"
            >
                <p class="text-gray-700 mb-2 text-sm">Expert Rating (Min Score)</p>
                <Select
                    name="expert_rating"
                    v-model="value.expertRating"
                    no-padding
                    placeholder="Select an Expert Rating"
                    :options="[
                        {value: null, name: 'Select an Expert Rating'},
                        {value: 1, name: '1'},
                        {value: 2, name: '2'},
                        {value: 3, name: '3'},
                        {value: 4, name: '4'},
                        {value: 5, name: '5'},
                    ]"
                />
            </div>

            <div
                class="w-full"
            >
                <p class="text-gray-700 mb-2 text-sm">Average RTP</p>
                <select2
                    :options="filterOptions.payoutRatios"
                    key="averageRtp"
                    id="averageRtp"
                    select-label="name"
                    track-by-option="id"
                    name="averageRtp"
                    class="mt-1"
                    @sync="(value) => filterChanged('payoutRatios', value)"
                    :value="value.payoutRatios"
                />
            </div>

            <div
                class="w-full"
            >
                <p class="text-gray-700 mb-2 text-sm">Payout Within</p>
                <Select
                    name="payout_within"
                    v-model="value.payoutWithin"
                    no-padding
                    placeholder="Select a Payout Within"
                    :options="[
                        {value: null, name: 'Select a Payout Within'},
                        {value: 15, name: '15 mins'},
                        {value: 30, name: '30 mins'},
                        {value: 45, name: '45 mins'},
                        {value: 60, name: '1 hour'},
                        {value: 90, name: '1 hour 30 mins'},
                        {value: 120, name: '2 hours'},
                        {value: 180, name: '3 hours'},
                        {value: 300, name: '5 hours'},
                        {value: 1440, name: '24 hours'},
                        {value: 2880, name: '48 hours'},
                        {value: 4320, name: '72 hours'},
                    ]"
                />
            </div>

            <div
                class="w-full flex flex-col justify-end"
            >
                <Btn
                    v-if="buttonEnabled"
                    type="button"
                    @click="$emit('filter')"
                    content="Load List"
                />

                <a
                    v-if="!buttonEnabled"
                    class="rounded-lg bg-gray-600 hover:bg-gray-500 text-white px-4 py-3 focus:outline-none opacity-50 cursor-not-allowed text-center"
                >
                    Load List
                </a>
            </div>

            <div
                class="w-full flex flex-col justify-end"
            >
                <Btn
                    v-if="buttonEnabled"
                    type="button"
                    @click="$emit('update')"
                    content="Update List"
                />

                <a
                    v-if="!buttonEnabled"
                    class="rounded-lg bg-gray-600 hover:bg-gray-500 text-white px-4 py-3 focus:outline-none opacity-50 cursor-not-allowed text-center"
                >
                    Update List
                </a>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: "BonusListFilter",
    props: {
        disabled: {
            type: Boolean,
            required: true,
        },
        filterOptions: {
            type: Object,
            required: true,
        },
        tooltip: {
            type: String,
            required: false,
        },
        showFilters: {
            type: Boolean,
            required: true,
        },
        value: {
            type: Object,
            required: true,
        },
        language: {
            type: Object,
            required: true,
        },
    },
    methods: {
        filterChanged(name, value) {
            this.value[name] = value || null
        },
    },
    computed: {
        buttonEnabled() {
            return !this.disabled;
        },
    },
}
</script>
